import { forwardRef, useCallback } from "react";
import NumberInput, {
  Props as NumberInputProps,
} from "components/Shared/Forms/NumberInput";
import { getPercentValue } from "utils/formatting";

// eslint-disable-next-line react/display-name
const PercentInput = forwardRef<HTMLInputElement, NumberInputProps>(
  ({ value, onChange, ...rest }, ref) => {
    const handleChange = useCallback(
      (newValue: string | number | null) => {
        onChange?.(getPercentValue(newValue, { isToDecimal: true }));
      },
      [onChange],
    );

    return (
      <NumberInput
        ref={ref}
        suffix="%"
        value={getPercentValue(value) ?? ""}
        onChange={handleChange}
        {...rest}
      />
    );
  },
);

export default PercentInput;
